import dJSON from 'dirty-json';

const moduleSelector = '.services-cards';

/**
 * Services Cards
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      const script = query.querySelector('script');
      if (!script) return;

      const { data } = dJSON.parse(script.parentNode.data);

      script.remove(); // cleanup

      data.forEach((item) => {
        const cardLink = item.button_link || '#';
        const cardHTML = /* html */ `
          <a href="${cardLink}" class="services-cards__card" target="_blank" rel="noopener noreferrer" aria-label="${item.title || ''} (opens in new tab)">
            <div class="services-cards__card__background">
              <img src="${item.background || ''}" alt="${item.title || ''}" />
            </div>
            <div class="services-cards__card__content">
              <div class="services-cards__card__icon">
                <img src="${item.icon || ''}" alt="${item.title || ''}" />
              </div>
              <h3 class="services-cards__card__title">${item.title || ''}</h3>
              <div class="services-cards__card__footer">
                <p class="services-cards__card__description">${item.description || ''}</p>
                ${item.button_link && item.button_text ? `
                  <button type="button" class="btn-custom primary" aria-label="${item.button_text || ''} (opens in new tab)">
                    ${item.button_text}
                  </button>
                ` : ''}
              </div>
            </div>
          </a>
        `;
        query.insertAdjacentHTML('beforeend', cardHTML);
      });

      // Handle button clicks to prevent double navigation
      query.querySelectorAll('.services-cards__card button').forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const card = button.closest('.services-cards__card');
          if (card && card.href && card.href !== '#') {
            window.open(card.href, '_blank', 'noopener,noreferrer');
          }
        });
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
